import { format } from "date-fns";
import VehicleCard from "./VehicleCard";
import { Vehicle } from "@/interface/entityInterface";
import { FC } from "react";

interface Props {
    date: string;
    odometer: number;
    vehicle: Vehicle;
} 

const Header: FC<Props> = ({date, odometer, vehicle}) => {
  return (
    <div className="flex justify-between">
      <VehicleCard vehicle={vehicle} />
      <div className="text-right">
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {format(date, "dd MMMM yyyy HH:mm")}
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {odometer} km
        </p>
      </div>
    </div>
  );
};

export default Header;
